export function updateErrorsForCards(
  cards,
  setBodyCardErrors,
  setButtonCardErrors
) {
  const newBodyErrors = {};
  const newButtonErrors = {};

  cards?.forEach((card, cardIndex) => {
    newBodyErrors[cardIndex] = false;
    newButtonErrors[cardIndex] = {};
    card.components?.forEach((component) => {
      if (component.type === "BUTTONS" && Array.isArray(component.buttons)) {
        component.buttons.forEach((button, buttonIndex) => {
          if (button.type.toLowerCase() === "url") {
            newButtonErrors[cardIndex][buttonIndex] = {
              title: false,
              url: false,
            };
          } else if (button.type.toLowerCase() === "quick_reply") {
            newButtonErrors[cardIndex][buttonIndex] = {
              text: false,
            };
          }
        });
      }
    });
  });

  if (cards) {
    setBodyCardErrors(newBodyErrors);
    setButtonCardErrors(newButtonErrors);
  }
}
